<div class="container mx-auto" style="max-width: 740px">
  <div id="print-class">
    <div class="divisa-row">
      <app-back-button
        class="divisa-col-md-8 divisa-col-12 mx-auto"
        [title]="'SHARED.RESERVATION_FOREIGN_CURRENCY_TITLE' | translate"
      ></app-back-button>
    </div>
    <div class="divisa-row mx-2 mb-4 mt-3">
      <div class="divisa-col-12">
        <h5
          class="text-center pb-2"
          style="font-size: 24px; font-weight: 800; margin-bottom: 0"
        >
          {{ 'SHARED.RESERVATION_SUCCESS_HEADLINE' | translate }}
        </h5>
        <p class="cuerpo text-center pt-2">
          {{
            'SHARED.RESERVATION_SUCCESS_DEADLINE'
              | translate
                : {
                    time: (reservacion.createdAt | date : 'HH:mm'),
                    date: (reservacion.createdAt | date : 'dd/MM/yyyy')
                  }
          }}
        </p>
      </div>
    </div>
    <app-reservacion
      [pagarTexto]="'SHARED.PAY_PENDING' | translate"
      [recibiTexto]="'SHARED.RECEIVE_PENDING' | translate"
      [cotizacion]="cotizacion"
      [typoCard]="'vencida'"
    ></app-reservacion>

    <div class="divisa-row mt-2 px-3 px-md-0">
      <div class="divisa-row subtitulo mt-4 mb-2">
        {{ 'SHARED.BRANCH_SECTION' | translate }}
      </div>
      <div class="divisa-row sucursal-card">
        <div class="col-3 col-md-1 my-auto">
          <img class="icon-divisas" src="./assets/img/circle-icon.svg" alt="" />
        </div>
        <div class="col-9 col-md-3 my-auto">
          <span class="sucursal-name"
            >{{ reservacion.idBranch.branchName }}.</span
          >
          <br />
          <span class="sucursal-locality">{{
            reservacion.idBranch.addresses.state
          }}</span>
        </div>
        <div class="col my-auto" style="display: inline-flex">
          <span class="sucursal-address">
            {{ reservacion.idBranch.addresses.street }},
            {{ reservacion.idBranch.addresses.sublocality }},
            {{ reservacion.idBranch.addresses.zipCode }}
            {{ reservacion.idBranch.addresses.locality }},
            {{ reservacion.idBranch.addresses.state }}
          </span>
        </div>
        <div class="col-1 p-0 my-auto">
          <mat-icon color="accent" svgIcon="fmd_good"></mat-icon>
        </div>
      </div>
    </div>
    <div class="divisa-row my-4">
      <div
        class="d-flex divisa-col-12 divisa-col-md-3 justify-content-center mb-4 mb-md-0"
      >
        <qrcode
          #parent
          [elementType]="elementType"
          [qrdata]="reservacion.order"
          [width]="144"
          [errorCorrectionLevel]="'H'"
          [margin]="1"
        ></qrcode>
      </div>
      <div
        class="divisa-col-12 divisa-col-md-1 d-flex justify-content-around flex-md-column my-none"
      >
        <button
          class="icon-button mb-md-auto"
          mat-mini-fab
          color="primary"
          [attr.aria-label]="'RESERVATIONS_DETAILS.QR_EMAIL_ARIA' | translate"
        >
          <mat-icon style="color: black" svgIcon="email"></mat-icon>
        </button>
        <button
          class="icon-button mt-md-auto"
          mat-mini-fab
          color="primary"
          [attr.aria-label]="'RESERVATIONS_DETAILS.QR_PRINT_ARIA' | translate"
          (click)="print()"
        >
          <mat-icon style="color: black" svgIcon="print"></mat-icon>
        </button>
      </div>
      <div class="divisa-col-12 divisa-col-md-8 pl-3 mt-4 mt-md-0">
        <div class="divisa-row">
          <p class="cuerpo">
            {{ 'RESERVATIONS_DETAILS.QR_INSTRUCTION' | translate }}
          </p>
        </div>
        <div class="divisa-row">
          <h6 class="text-color-primary">{{ reservacion.order }}</h6>
        </div>
        <div class="divisa-row">
          <div class="divisa-col-6 divisa-row">
            <img
              class="icon-divisas"
              src="./assets/img/circle-icon-primary.svg"
              alt=""
            />
            <h6 class="m-1 ml-1"
              >{{ reservacion.quotation?.calculatedPoints ?? 0 }}
              {{ 'RESERVATIONS_DETAILS.POINTS_ABBREV' | translate }}</h6
            >
          </div>
          <div class="divisa-col-6 divisa-row">
            <p class="divisa-col cuerpo text-right pr-3">
              {{ 'RESERVATION_CONFIRMATION.POINTS_CAPTION' | translate }}
            </p>
            <button
              class="icon-button-secondary active"
              mat-mini-fab
              color="primary"
              [matTooltip]="'RESERVATION_CONFIRMATION.POINTS_HELP' | translate"
              [attr.aria-label]="'SHARED.QR_HELP_ARIA' | translate"
            >
              <mat-icon svgIcon="question_mark"></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="divisa-row mt-3">
    <div class="divisa-col-12 divisa-col-md-6 pr-md-1 pb-md-0 pb-2">
      <button
        class="btn btn-outline-light divisa-col-12"
        type="button"
        (click)="cancelarReservacion()"
      >
        {{ 'RESERVATIONS_DETAILS.BTN_CANCEL_RESERVATION' | translate }}
      </button>
    </div>
    <div class="divisa-col-12 divisa-col-md-6 pl-md-1 pt-md-0 pt-2">
      <button
        class="btn btn-primary divisa-col-12"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseTwo"
        aria-expanded="true"
        aria-controls="collapseTwo"
        (click)="saveAsImage(parent)"
      >
        {{ 'RESERVATIONS_DETAILS.BTN_DOWNLOAD' | translate }}
        <i class="ml-4" data-feather="download"></i>
      </button>
    </div>
  </div>
</div>
